import { useQuery as useReferralQuery } from "@faire/web-api/api/known-referrer-adoption-landing-page/brandLeadReferralToken/get-hooks";
import { useParams } from "react-router-dom";

export const useKnownReferrer = () => {
  const params = useParams<{ brandLeadReferralToken: string }>();
  const { brandLeadReferralToken } = params;

  const { data, isSuccess } = useReferralQuery(brandLeadReferralToken);

  return {
    referrer_name: data?.referrer_name,
    calendar_url: data?.calendar_url,
    referral_url: data?.referral_url,
    number_of_referrals: data?.number_of_referrals,
    is_success: isSuccess,
  };
};
